import React from 'react';
import './StyledPagination.css';

/**
 * StyledPagination — Reusable Prev/Next pagination bar for server-side tables.
 *
 * Design-system styled; works with server-side pagination where the API returns
 * page metadata (currentPage/totalPages/totalItems/hasNextPage/hasPrevPage).
 *
 * @param {number} currentPage
 * @param {number} totalPages
 * @param {number} totalItems
 * @param {boolean} hasPrevPage
 * @param {boolean} hasNextPage
 * @param {function} onPrev
 * @param {function} onNext
 * @param {string} itemLabel - noun for the count (default "items")
 */
const StyledPagination = ({
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  hasPrevPage = false,
  hasNextPage = false,
  onPrev,
  onNext,
  itemLabel = 'items',
  className = '',
}) => {
  return (
    <div className={`ck-pagination ${className}`}>
      <span className="ck-pagination-info">
        Page {currentPage} of {totalPages} ({totalItems} {itemLabel})
      </span>
      <div className="ck-pagination-controls">
        <button
          type="button"
          className="ck-pagination-btn"
          disabled={!hasPrevPage}
          onClick={onPrev}
          aria-label="Previous page"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Prev
        </button>
        <button
          type="button"
          className="ck-pagination-btn"
          disabled={!hasNextPage}
          onClick={onNext}
          aria-label="Next page"
        >
          Next
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StyledPagination;
